import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  open: false,
  x: undefined,
  y: undefined,
  submenu: undefined,
  onClickBlanket: undefined
};

const contextMenuSlice = createSlice({
  name: 'contextMenu',
  initialState,
  reducers: {
    openContextMenu: (state, action) => {
      state.open = true;
      state.x = action.payload.x;
      state.y = action.payload.y;
      state.submenu = action.payload.submenu;
      state.onClickBlanket = action.payload.onClickBlanket;
    },
    closeContextMenu: () => initialState
  }
});

export const { openContextMenu, closeContextMenu } = contextMenuSlice.actions;
export const useContextMenuSlice = createSelectorFn(contextMenuSlice);
export default contextMenuSlice;
